// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2Mrwg","video":"_3y1Xj","photo":"_2x4su","card-content":"_3QMB8","icon-wrapper":"_2N_tK","date":"Qu45Y"};